import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { DiagnosisSection } from '../components/DiagnosisSection';
import { SystemSection } from '../components/SystemSection';
import { ResultsSection } from '../components/ResultsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { StickyMobileCTA } from '../components/StickyMobileCTA';
export function LandingPage() {
  return <main className="min-h-screen bg-carbon w-full overflow-x-hidden pb-20 md:pb-0" data-id="element-187">
      <HeroSection data-id="element-188" />
      <TrustBar data-id="element-189" />
      <DiagnosisSection data-id="element-190" />
      <SystemSection data-id="element-191" />
      <ResultsSection data-id="element-192" />
      <GuaranteeSection data-id="element-193" />
      <FinalCTASection data-id="element-194" />
      <StickyMobileCTA data-id="element-195" />
    </main>;
}